function hasPermission(meta, permissions, isSuper) {
  if (isSuper) return true
  const required = meta && meta.perm
  if (!required) return true
  const codes = Array.isArray(required) ? required : [required]
  return codes.some(code => permissions.includes(code))
}

function filterMenuRoutesByPerm(routes, permissions) {
  const list = Array.isArray(permissions) ? permissions : []
  const isSuper = list.includes('*')

  return (routes || []).reduce((result, route) => {
    if (!route || !hasPermission(route.meta, list, isSuper)) return result

    if (Array.isArray(route.children)) {
      const children = filterMenuRoutesByPerm(route.children, list)
      if (children.length > 0) result.push({ ...route, children })
      return result
    }

    result.push({ ...route })
    return result
  }, [])
}

function resolveMenuPath(basePath, path) {
  const value = String(path || '')
  if (value.startsWith('/')) return value
  const base = String(basePath || '').replace(/\/$/, '')
  return `${base}/${value}`.replace(/\/+/g, '/')
}

function findFirstNavigablePath(routes, prefix, basePath = '') {
  for (const route of routes || []) {
    if (!route) continue
    const resolvedPath = resolveMenuPath(basePath, route.path)
    if (Array.isArray(route.children) && route.children.length > 0) {
      const childPath = findFirstNavigablePath(route.children, prefix, resolvedPath)
      if (childPath) return childPath
      continue
    }
    if (route.redirect || (route.meta && route.meta.newWindow) || resolvedPath.includes(':')) continue
    if (resolvedPath.startsWith(prefix + '/')) return resolvedPath
  }
  return ''
}

module.exports = {
  filterMenuRoutesByPerm,
  findFirstNavigablePath,
  resolveMenuPath
}
